// extracted by mini-css-extract-plugin
module.exports = {"form":"HelpForm_form__zz3_s","submit":"HelpForm_submit__2YIGX","errorText":"HelpForm_errorText__1bb8z","formItem":"HelpForm_formItem__lJM_L"};